import { Directive, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
	selector: '[postcodeRangeCheck]'
})

export class PostcodeRangeCheckDirective {

	@HostListener("input")
	onInput() {
		let nativeVal;
		// for input elements
		if (this.ele.nativeElement.value) {
			nativeVal = this.ele.nativeElement.value;
		}
		// for mdl-textfield input elements
		else if (this.ele.nativeElement.getElementsByClassName("mdl-textfield__input")[0].value) {
			nativeVal = this.ele.nativeElement.getElementsByClassName("mdl-textfield__input")[0].value;
		}
		this.validationResult.emit(this.checkNumberInRange(nativeVal));
	}

	@Input() ranges: { start: number, end: number }[];
	@Output() validationResult: EventEmitter<any> = new EventEmitter();

	constructor(private ele: ElementRef) { }

	private checkNumberInRange(nativeVal: any): boolean {
		if (this.ranges?.length && nativeVal?.length === 4) {
			for (const range of this.ranges) {
				if (+nativeVal >= +range.start && +nativeVal <= +range.end) {
					return true;
				}
			}
		}
		return false;
	}
}
